import clsx from "clsx";
import React, { FC } from "react";
import { TimeTrackerStatusIcon } from "./TimeTrackerStatusIcon";

const RunningTimer: FC<{
  runningTime: string;
  onClickTimerIcon: () => void;
  className?: string;
  timeRunning: boolean;
}> = ({ runningTime, onClickTimerIcon, className, timeRunning }) => {
  return (
    <div
      className={clsx(
        "w-full flex items-center justify-between p-2 bg-gray-400 border border-gray-100 rounded",
        className,
      )}
    >
      <span className="text-sm text-black font-normal">{runningTime}</span>
      <TimeTrackerStatusIcon
        size={24}
        isActive={timeRunning}
        timerIconProps={{
          onClick: onClickTimerIcon,
        }}
      />
    </div>
  );
};

export default RunningTimer;
